import { Link } from "react-router-dom";
import { MapPin, ArrowRight, Phone } from "lucide-react";

const data = [
  {
    title: "Lincoln Park",
    description: "Serving homes and apartments around Clark Street, Fullerton Ave, and the lakefront area.",
    slug: "lincoln-park",
  },
  {
    title: "Wicker Park",
    description: "Plumbing services near Milwaukee Ave, Division Street, and surrounding residential blocks.",
    slug: "wicker-park",
  },
  {
    title: "Lakeview",
    description: "Local plumbers for Lakeview East, Belmont Ave, and neighborhoods near the lake.",
    slug: "lakeview",
  },
  {
    title: "Logan Square",
    description: "Fast plumbing help near Logan Blvd, Fullerton Ave, and surrounding homes.",
    slug: "logan-square",
  },
  {
    title: "River North",
    description: "Serving condos, businesses, and residences around State Street and Hubbard Street.",
    slug: "river-north",
  },
  {
    title: "South Loop",
    description: "Professional plumbing services near Michigan Ave, Roosevelt Rd, and nearby areas.",
    slug: "south-loop",
  },
  {
    title: "Old Town",
    description: "Local plumbers around Wells Street, North Ave, and historic residential zones.",
    slug: "old-town",
  },
  {
    title: "Gold Coast",
    description: "High-end residential and condo plumbing near Rush Street and lakefront properties.",
    slug: "gold-coast",
  },
];

export default function LocationsGrid() {
  return (
    <section className="max-w-[90%] mx-auto xl:max-w-6xl space-y-8">

      <div className="space-y-4">
        <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
          Where We Work
        </div>
        <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
          Chicago Neighborhoods We Serve
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {data.map((item, index) => (
          <div
            key={index}
            className="group bg-white border border-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col gap-5"
          >
            <div className="w-11 h-11 bg-blue-50 rounded-xl flex items-center justify-center group-hover:bg-blue-600 transition-colors duration-300">
              <MapPin className="w-5 h-5 text-blue-600 group-hover:text-white transition-colors duration-300" />
            </div>

            <div className="flex-1 space-y-1.5">
              <h4 className="font-bold text-gray-900 text-[16px]">{item.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
            </div>

            <div className="flex items-center gap-3 pt-1 border-t border-gray-100">
            <Link
                to={`/locations/${item.slug}`}
                className="flex items-center gap-1 text-xs font-bold text-gray-600 hover:text-blue-600 transition-colors"
              >
                Learn More <ArrowRight className="w-3.5 h-3.5" />
              </Link>
              <span className="text-gray-200">|</span>
              <a
                href="tel:(312) 555-0147"
                className="flex items-center gap-1 text-xs font-bold text-blue-600 hover:text-blue-700 transition-colors"
              >
                <Phone className="w-3.5 h-3.5" /> Call Now
              </a>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}